module.exports = __webpack_public_path__ + "img/wangan.d0289dc0.png";